import { computed, provide, ref } from 'vue'

export const useFiltersProvider = ({
  initialState,
  availableFilters,
  tracking,
}) => {
  const filtersState = ref({ ...initialState })

  const activeFilters = computed(() => {
    const filters = Object.entries({
      ...filtersState.value,
    })
      .map(([key, value]) => {
        if (typeof value === 'object') return [key, value.value]
        else return [key, value]
      })
      .filter(([, value]) => {
        const isNotEmptyString = typeof value === 'string' && value
        const isNotEmptyArray = Array.isArray(value) && value.length
        return isNotEmptyString || isNotEmptyArray
      })

    return Object.fromEntries(filters)
  })

  const isAnyFilterActive = computed(() => {
    return Object.keys(filtersState.value).some((key) => {
      const filterValue = filtersState.value[key].value
      return Array.isArray(filterValue)
        ? filterValue.length
        : Boolean(filterValue)
    })
  })

  const activeFiltersCount = computed(() => {
    return Object.values(activeFilters.value).reduce((acc, value) => {
      return Array.isArray(value) ? acc + value.length : acc + 1
    }, 0)
  })

  const loadPreselectedFilters = (params) => {
    Object.keys(params).forEach((key) => {
      const isFiltersOption = Object.keys(filtersState.value).includes(key)
      if (!isFiltersOption) return
      filtersState.value[key].value = params[key]
    })
  }

  const clearFilters = () => {
    Object.keys(filtersState.value).forEach((key) => {
      filtersState.value[key].value = Array.isArray(
        filtersState.value[key].value,
      )
        ? []
        : null
    })
  }

  provide('filtersState', filtersState)
  provide('availableFilters', availableFilters)
  provide('tracking', tracking)

  return {
    filtersState,
    activeFilters,
    isAnyFilterActive,
    activeFiltersCount,
    loadPreselectedFilters,
    clearFilters,
  }
}
